import { useParams } from 'react-router-dom';
import { useApiQuery } from '../../hooks/useApiQuery';
import { humanize, shortId } from '../../lib/format';
import ProductPrice from '../ProductPrice/ProductPrice';
import PriceBreakdown from '../PriceBreakdown/PriceBreakdown';
import OrderTimeline from './OrderTimeline';
import { Order } from '../../types/orders';
import './Orders.css';
import { ORDER_POLL_MS } from '../../lib/constants';
export default function OrderDetailsPage() {
  const { orderId } = useParams();
  const { data: order, error } = useApiQuery<Order>(orderId ? `/orders/${orderId}` : null, {
    pollMs: ORDER_POLL_MS,
  });
  return (
    <section className="page-container account-page">
      <h1>Order tracking</h1>
      {error && <p role="alert">{error}</p>}
      {order ? (
        <>
          <p>
            Order {shortId(order.id)} · {humanize(order.status)}
          </p>
          <OrderTimeline order={order} />
          {order.tracking_reference && (
            <p>
              {order.courier}: {order.tracking_reference}{' '}
              {order.tracking_url && (
                <a href={order.tracking_url} target="_blank" rel="noreferrer">
                  Courier tracking
                </a>
              )}
            </p>
          )}
          <p>Delivered by {order.snapshot.delivery.latest}</p>
          {order.snapshot.items.map((l) => (
            <article key={l.item_id}>
              <h2>
                {l.display_name} × {l.quantity}
              </h2>
              <ProductPrice pricing={l.pricing} />
            </article>
          ))}
          <PriceBreakdown
            rows={[
              ['Product charge', order.snapshot.product_paise],
              ['Product discount', -order.snapshot.discount_paise],
              ['Transportation', order.snapshot.shipping_paise],
              ['Reward points used', -order.snapshot.points_value_paise],
              ['Amount paid', order.snapshot.amount_paise],
            ]}
          />
          <p>Refund: {order.refund_status}</p>
        </>
      ) : (
        !error && <p role="status">Loading order…</p>
      )}
    </section>
  );
}
